<template>
  <div id="app">
    <Layout class="xl-main">
      <Sider v-if="showHead" hide-trigger :width="MenuWidth">
        <StoreMenu ref="StoreMenu" v-if="showHead && $store.state.store_type == 0"></StoreMenu>
        <MenuLeft ref="menu" v-else-if="showHead && $store.state.store_type == 1"></MenuLeft>
        <PrivateMenu ref="PrivateMenu" v-else-if="showHead && $store.state.store_type == 2"></PrivateMenu>
        <ClinicMenu ref="ClinicMenu" v-else-if="showHead && $store.state.store_type == 3"></ClinicMenu>
        <MechanismMenu ref="MechanismMenu" v-else-if="showHead && $store.state.store_type == 4"></MechanismMenu>
      </Sider>
      <Layout :style="{background: '#ebeef5'}">
        <Header style="z-index: 999;" v-if="showHead" :style="{background: '#fff',padding:0,height:'auto'}">
          <div v-if="showHead" class="nav-header">
            <div class="nav-l">
              <!--只有saas系统、私有管理系统、应用后台系统才显示有效期-->
              <div v-if="$store.state.store_type==1 || $store.state.store_type==2">
                <div class="xl-private-version" v-if="$store.state.store_type == 1">
                  <i class="ri-vip-diamond-fill iconfont icon-vip-fill"></i>
                  <span>{{(userInfo?(userInfo.version_text?(userInfo.version_text):''):'')}}</span>
                </div>
                <span class="xl-expire"
                  v-if="userInfo && userInfo.is_private == 1">{{ (userInfo && userInfo.is_private==1 && $store.state.store_type==1) ? '应用' : '系统' }}到期时间：{{ userInfo ? (userInfo.expire || '永久版，没有期限') : '--' }}</span>
                <Icon size="16" type="md-refresh" @click="clickReload"
                  style="position: relative; top: 1px; cursor: pointer;color: #999999" title="刷新" />
              </div>
            </div>
            <div class="nav-r">
              <div
                v-if="($store.state.store_type == 1 || $store.state.store_type == 4) && ( userInfo &&  userInfo.uname != 18766666666)">
                <i class="iconfont icon-baobiaokongzhitai"
                  @click="toUrl($store.state.store_type == 4?'/device/mechanism_device_home':'/device/home')"></i>
                <Divider type="vertical" />
              </div>
              <!-- <div v-if="$store.state.store_type == 1 || $store.state.store_type == 4">
                <a :href="$store.state.store_type == 4?'https://www.kancloud.cn/xunliao/xl_jggl/3132594':'https://www.kancloud.cn/xunliao/xunliao/2685095'"
                  style="color: #333333;" target="_blank">操作手册</a>
                <Divider type="vertical" />
              </div> -->
              <div v-if="$store.state.store_type == 1">
                <Poptip trigger="hover" title="H5地址">
                  <a class="a-txt" href="javascript:;">H5端</a>
                  <div slot="content">
                    <vue-qr logoSrc="" :text="FrontUrl+'/?store_id='+$store.state.admin.store_id+'#/'" :size="220">
                    </vue-qr>
                  </div>
                </Poptip>
                <Divider type="vertical" />
              </div>
              <!-- 门诊数据大屏 -->
              <template v-if="$store.state.store_type == 3 && userInfo">
                <i class="iconfont icon-baobiaokongzhitai" style="margin-right: 24px;"
                  @click="toUrl('/clinic/data/home')"></i>
              </template>
              <template v-if="$store.state.store_type == 3 && userInfo">
                <clinic-remind ref="clinicRemind"></clinic-remind>
              </template>
              <Dropdown placement="top" trigger="click" v-if="userInfo && userInfo.uname != 18766666666"
                @on-click="clickDropdown">
                <a href="javascript:void(0)">{{ !userInfo?'admin':userInfo.uname }}
                  <Icon type="ios-arrow-down"></Icon>
                </a>
                <template v-if="$store.state.store_type==0">
                  <DropdownMenu slot="list">
                    <DropdownItem name="3">我的账号</DropdownItem>
                    <DropdownItem name="4">退出登录</DropdownItem>
                  </DropdownMenu>
                </template>
                <template v-else>
                  <DropdownMenu slot="list">
                    <DropdownItem name="0" v-if="userInfo && $store.state.store_type == 1 && userInfo.staff_type == 1">
                      返回系统
                    </DropdownItem>
                    <DropdownItem name="7" v-if="$store.state.store_type == 1 || $store.state.store_type == 4">锁定屏幕
                    </DropdownItem>
                    <!-- <DropdownItem name="2">更新缓存</DropdownItem> -->
                    <DropdownItem name="6" v-if="$store.state.store_type==2 && userInfo"
                      v-check-permit="[10,11,19,20,21,22,23,24]">我的账号</DropdownItem>
                    <DropdownItem name="5" v-if="$store.state.store_type==3">修改密码</DropdownItem>
                    <DropdownItem name="1">退出登录</DropdownItem>
                  </DropdownMenu>
                </template>
              </Dropdown>
            </div>
          </div>
          <div v-if="showHead && $store.state.store_type==1" class="nav-tabs nav-tabs-fix">
            <div class="nav-tabs-main">
              <div class="tabs-card">
                <div class="tabs-card-wrap">
                  <div class="tabs-card-scroll" ref="tabsWidth">
                    <div class="tabs-nav-prev" v-if="showBtn" @click="changTabs(false,0)">
                      <Icon type="ios-arrow-back" />
                    </div>
                    <div class="tabs-nav-next" v-if="showBtn" @click="changTabs(true,0)">
                      <Icon type="ios-arrow-forward" />
                    </div>
                    <div class="tabs-card-content" :style="{transform: `translateX(${translateX}px)`}">
                      <div class="flex" ref="boxWidth">
                        <div class="tabs-content-tab" :ref="$route.path=='/admin/index'?'ItemWidth':''"
                          :class="{'tabs-content-tab-active':$route.path=='/admin/index'}" @click="toUrl('/index')">
                          <div class="tabs-content-tab-title">控制台</div>
                        </div>
                        <div :ref="$route.path=='/admin'+item.path?'ItemWidth':''" class="tabs-content-tab"
                          :class="{'tabs-content-tab-active':$route.path=='/admin'+item.path}"
                          v-for="(item,index) in $store.state.routeItem" :key="index" @click="addmenu(item)">
                          <span class="">{{item.title}}</span>
                          <i style="margin-left: 6px;" class="iconfont icon-chahao" @click="delTag(item)"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tabs-close">
                <Dropdown style="display: block" transfer trigger="click" @on-click="changeClose">
                  <div class="tabs-close-icon">
                    <Icon type="ios-arrow-down" />
                  </div>
                  <DropdownMenu slot="list">
                    <DropdownItem name="close_all">全部关闭</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
          </div>
        </Header>
        <Content style="overflow-x: auto;">
          <div :class="{'main': $store.state.store_type == 4?false:true,'main-view':showHead}">
            <div v-if="$store.state.store_type == 1 && (userInfo && userInfo.is_free == 1) && showHead"
              class="free-version">
              <span>您当前的版本为</span>
              <div class="free-tag">{{ userInfo.version_text }}</div>
              <span>，若想尝试更多功能，可升级更高版本！</span>
              <Button @click="toUrl('/apply/upgrade')">立即升级</Button>
            </div>
            <keep-alive :include="cachedViews">
            <router-view ref="reload" v-if="$route.meta.keepAlive" />
            </keep-alive>
            <router-view ref="reload" v-if="!$route.meta.keepAlive"/>
          </div>
        </Content>
      </Layout>
    </Layout>
    <!-- 修改密码 -->
    <Modal v-model="change_password" title="修改密码" :footer-hide="true" width="452">
      <Form v-if="$store.state.store_type==3">
        <div style="align-items: center; text-align: center;" class="clinic">
          <Input type="text" v-model="$store.state.admin.phone" :disabled="true"
            style="width: 354px; margin-bottom: 20px;" size="large" prefix="ios-phone-portrait" placeholder="医生账号" />
          <div style="margin-bottom: 20px;">
            <Input v-model="modify.code" style="width: 236px;" prefix="ios-mail-outline" size="large"
              placeholder="输入验证码" />
            <Button v-if="show_countdown" style="width: 107px;margin-left: 8px; height: 40px; color: #C09351;"
              @click="verification">获取验证码</Button>
            <Button v-else style="width: 107px;margin-left: 8px; height: 40px; color: #C09351;">{{ countdown }}</Button>
          </div>
          <Input v-model="modify.password" style="width: 354px; margin-bottom: 20px;" size="large"
            prefix="ios-lock-outline" placeholder="输入新密码" type="password" password />
          <Button style="width: 354px; height: 40px; background-color: #C09351; color: #fff;"
            @click="confirm_modify"><span style=" font-size: 18px;">确认修改</span></Button>
        </div>
      </Form>
    </Modal>
    <!-- 设备报警 -->
    <template v-if="($store.state.store_type == 1 || $store.state.store_type == 4) && userInfo ">
      <receive-alarm ref="receive_alarm"></receive-alarm>
    </template>
    <!-- 锁定屏幕 -->
    <template v-if="($store.state.store_type == 1 || $store.state.store_type == 4) && userInfo && showHead">
      <lock-screen ref="lock_screen" @on-change="systemLogout(1)"></lock-screen>
    </template>
    <!-- 消息提醒 -->
    <template v-if="$store.state.store_type == 1 && userInfo">
      <AdmTips ref="adm_tips"></AdmTips>
    </template>
  </div>
</template>

<script>
  // 引入生成二维码插件
  import vueQr from 'vue-qr'
  import MenuLeft from '@/components/public/MenuLeft.vue'
  import StoreMenu from '@/components/public/StoreMenu'
  import PrivateMenu from '@/components/public/privateMenu'
  import ClinicMenu from "@/components/public/ClinicMenu";
  import MechanismMenu from '@/components/public/MechanismMenu.vue'
  // 引用 门诊消息提醒 组件
  import ClinicRemind from "@/components/clinic/navbar/remind";
  // 设备报警提醒
  import ReceiveAlarm from '@/components/adm/healthy/receive_alarm'
  // 锁定屏幕
  import LockScreen from '@/components/adm/user/lock_screen'
  // 消息通知提醒
  import AdmTips from '@/components/public/AdmTips'
  import md5 from 'js-md5'
  import {mapState} from 'vuex'
  export default {
    components: {
      MenuLeft,
      vueQr,
      StoreMenu,
      PrivateMenu,
      ClinicMenu,
      MechanismMenu,
      ClinicRemind,
      ReceiveAlarm,
      LockScreen,
      AdmTips
    },
    name: 'App',
    data() {
      return {
        userInfo: JSON.parse(localStorage.getItem('userInfo')),
        showHead: true,
        showBtn: false,
        translateX: 0,
        change_password: false,
        modify: {
          phone: null,
          code_id: null,
          code: null,
          password: null,
        },
        countdown: null,
        show_countdown: true,
        timer: null
      }
    },
    created() {
      var userinfo = localStorage.getItem('userInfo')
      if (userinfo) this.$store.dispatch("setAdmin", JSON.parse(userinfo))

      var apply = localStorage.getItem('apply_info')
      if (apply) this.$store.dispatch("setApplyInfo", JSON.parse(apply))

      var store_type = localStorage.getItem('store_type')
      if (localStorage.getItem('userInfo')) {
        this.$store.commit('update_admin', JSON.parse(localStorage.getItem('userInfo')))
      }
      if (typeof store_type === 'undefined' && store_type == undefined) localStorage.setItem('store_type', this.$store
        .state.store_type)
      else this.$store.commit('update_type', store_type)
    },
    computed: {
      MenuWidth() {
        var width = 240
        if (this.$store.state.store_type == 1) {
          width = (this.$store.state.Indent && this.$store.state.menuId && this.$store.state.menuItem[this.$store.state
            .menuId] && this.$store.state.menuItem[this.$store.state.menuId][0].children.length) ? 240 : 110
        } else {
          width = 180
        }
        return width
      },
      ...mapState(['cachedViews'])
    },
    watch: {
      '$route.path': function(path, ohl) {
        var pathList = [
          '/admin/login',
          '/admin/store/' + this.$route.params.store_id,
          '/admin/apply/index',
          '/admin/apply/create_apply',
          '/admin/clinic/login/' + this.$route.params.store_id,
          '/admin/clinic/data/home',
          '/admin/device/home',
          '/admin/mechanism/login/' + this.$route.params.store_id,
          '/admin/device/mechanism_device_home',
          '/admin/clinic/outpatient/home',
        ]
        if (pathList.indexOf(path) == -1) {
          this.showHead = true;
        } else {
          this.showHead = false;
        }
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (this.$store.state.store_type == 1) this.upScroll()
      }
    },
    methods: {
      clickDropdown(index) {
        var _this = this
        // 返回系统
        if (index == 0) {
          _this.$store.commit("DEL_ALL_TAG")
          _this.$store.commit('update_type', 2)
          localStorage.setItem('store_type', 2);
          // 到期时间
          if (localStorage.getItem('SYSTEM_ADMIN') != null) {
            let admin = localStorage.getItem('SYSTEM_ADMIN')
            admin = JSON.parse(admin)
            localStorage.setItem('userInfo', JSON.stringify(admin.userInfo))
            _this.userInfo = admin.userInfo
          }

          localStorage.removeItem('apply_info');
          localStorage.removeItem('SYSTEM_SAAS_OR_APP');
          _this.$store.dispatch('setApplyInfo', {
            id: 0,
            store_id: ''
          })
          _this.$refs.receive_alarm.close(); // 关闭接收设备报警定时器
          _this.$refs.adm_tips.close(); //关闭消息通知
          setTimeout(function() {
            _this.toUrl('/private/apply_list')
          }, 300)
        } else if (index == 1 || index == 4) {
          _this.$Modal.confirm({
            title: '提示',
            content: '确认退出登录吗？',
            onOk: () => {
              _this.systemLogout(index)
            }
          })
        } else if (index == 3) {
          _this.$Modal.confirm({
            title: '提示',
            content: '确认退出登录吗？',
            onOk: () => {
              _this.systemLogout(index)
            }
          })
        } else if (index == 2) {
          //清除缓存-待完善
        } else if (index == 5) {
          if (this.$store.state.admin.id) {
            this.change_password = true
            this.modify = {
              code_id: null,
              code: null,
              password: null,
            }
          } else {
            return this.alertErr('请先登录！')
          }
        } else if (index == 6) {
          this.toUrl('/private/super/config')
        } else if (index == 7) {
          this.$refs.lock_screen.open();
        }
      },
      // 退出登录
      systemLogout(index) {
        let _this = this
        let url = ['/store/login_out', '/adm/login_out', '/adm/login_out', '/clinic/login_out', '/machine/login_out']
        var apiurl = url[this.$store.state.store_type]
        _this.requestApi(apiurl).then(function(res) {
          if (res.status) {
            _this.showHead = false
            localStorage.setItem('isActive', 0)
            localStorage.removeItem('token')
            localStorage.removeItem('userInfo')
            localStorage.removeItem('lock_screen_password');
            // ================ 同浏览器多标签页操作不同系统 start
            if (_this.$store.state.store_type == 3) {
              _this.$refs['clinicRemind'].close(); // 关闭 获取消息的定时器
              localStorage.removeItem('SYSTEM_CLINIC')
              sessionStorage.removeItem('clinicSelIndex')
              sessionStorage.removeItem('clinicChildIndex')
            } else if (_this.$store.state.store_type == 0) {
              localStorage.removeItem('SYSTEM_STORE')
            } else if (_this.$store.state.store_type == 2) {
              localStorage.removeItem('SYSTEM_ADMIN')
            } else if (_this.$store.state.store_type == 4) {
              localStorage.removeItem('SYSTEM_MECHANISM')
              localStorage.removeItem('mechan_menu_index')
            } else {
              _this.$refs.receive_alarm.close(); // 关闭接收设备报警定时器
              _this.$refs.adm_tips.close(); //关闭消息通知
              localStorage.removeItem('SYSTEM_SAAS_OR_APP')
            }
            // ================ 同浏览器多标签页操作不同系统 ends
            setTimeout(function() {
              if (_this.$store.state.store_type == 3) {
                _this.toUrl('/clinic/login/' + _this.$store.state.admin.store_id)
              } else if (_this.$store.state.store_type == 0) {
                _this.toUrl('/store/' + _this.$store.state.admin.store_id)
              } else if (_this.$store.state.store_type == 4) {
                _this.toUrl('/mechanism/login/' + _this.$store.state.admin.store_id)
              } else {
                _this.toUrl('/login')
              }
            }, 500)
            _this.alertSucc(res.msg)
          } else {
            _this.alertErr(res.msg)
          }
        }).catch(function(error) {
          _this.alertErr(error)
        })
      },
      // 多商户退出登录
      storeLogout(index) {
        this.toUrl('/store_member/storeinfo')
      },
      // 刷新
      clickReload() {
        if (this.$refs.reload.clickReload) this.$refs.reload.clickReload()
        else if (this.$refs.reload.init) this.$refs.reload.init()
      },
      addmenu(item) {
        this.toUrl(item.path)
      },
      delTag(item) {
        this.$store.dispatch("delTag", item);
      },
      upScroll() {
        let _this = this;
        if (
          this.$route.path == '/admin/login' ||
          this.$route.path == '/admin/apply/index' ||
          this.$route.path == '/admin/apply/create_apply' ||
          this.$route.path.indexOf('/store/') != -1 ||
          this.$store.state.store_type != 1 ||
          this.showHead == false
        ) return false;

        setTimeout(function() {
          var ItemWidth = _this.$refs.ItemWidth;
          if (_this.$route.path == '/admin/index') {
            _this.changTabs(false, 0)
          } else {
            let tabsWidth = _this.$refs.tabsWidth?_this.$refs.tabsWidth.offsetWidth:0;
            let boxWidth = _this.$refs.boxWidth?_this.$refs.boxWidth.offsetWidth:0;
            let offsetLeft = ItemWidth && ItemWidth.length ? ItemWidth[0].offsetLeft : 0;
            let offsetWidth = ItemWidth && ItemWidth.length ? ItemWidth[0].offsetWidth : 0;
            if (boxWidth < tabsWidth) {
              _this.changTabs(false, 0)
            } else {
              _this.showBtn = true;
              if ((offsetLeft + offsetWidth) > tabsWidth - 40) _this.changTabs(false, (offsetLeft - tabsWidth +
                offsetWidth + 40) * -1)
              else if ((offsetLeft + offsetWidth + 40) < Math.abs(_this.translateX)) _this.changTabs(false,
                offsetLeft - 40)
              else _this.changTabs(false, 0)
            }
          }
        }, 100)
      },
      changTabs(type, width) {
        var tabsWidth = this.$refs.tabsWidth.offsetWidth,
          boxWidth = this.$refs.boxWidth.offsetWidth,
          leftWidth = boxWidth - tabsWidth;
        width = width || 0;
        if (width == 0) {
          if (type) width = (leftWidth + 40) * -1;
          else width = this.showBtn ? 40 : 0;
        }
        this.translateX = width;
      },
      changeClose(name) {
        this.showBtn = false
        this.changTabs(false, 0)
        if (name == 'close_all') this.$store.commit("DEL_ALL_TAG");
      },
      // 获取验证码
      verification() {
        const TIME_COUNT = 60;
        this.countdown = TIME_COUNT;
        this.show_countdown = false
        var _this = this
        this.requestApi('/clinic/obtain_countdown', {
          phone: this.$store.state.admin.phone,
          store_id: this.$store.state.admin.store_id
        }).then(function(res) {
          if (res.code == 200) {
            console.log(res)
            _this.modify.code_id = res.code_id
            _this.alertSucc('获取验证码成功')
          } else {
            _this.alertErr(res.msg)
          }
        })
        this.timer = setInterval(() => {
          this.countdown--
          if (this.countdown == 0 || this.change_password == false) {
            console.log(this.change_password)
            clearInterval(this.timer);
            this.show_countdown = true
          }
        }, 1000)
      },
      confirm_modify() {
        console.log(this.modify)
        if (!this.modify.code) return this.alertErr('请输入验证码')
        if (!this.modify.password) return this.alertErr('请输入密码')
        this.modify.phone = this.$store.state.admin.phone
        var pwd = JSON.parse(JSON.stringify(this.modify.password))
        pwd = md5(pwd).substr(2, 28)
        var _this = this
        this.requestApi('/clinic/doctor_change_pwd', {
          modify: this.modify,
          store_id: this.$store.state.admin.store_id,
          pwd: pwd
        }).then(function(res) {
          if (res.code == 200) {
            _this.alertSucc(res.msg)
            _this.change_password = false
            _this.show_countdown = true
          } else {
            _this.alertErr(res.msg)
          }
        })
      },
    }
  }
</script>

<style>
  @import "./assets/css/public/index.css";
  @import "./assets/css/public/navbar.css";
  @import "./assets/css/public/clinic.css";
  @import "../static/iconfont.css";

  .xl-private-version {
    display: inline-block;
    padding: 2px 10px;
    background: #fbe239;
    line-height: 20px;
    font-size: 12px;
    color: #967333;
  }

  .xl-private-version i {
    margin-right: 4px;
    position: relative;
    top: 1px;
  }

  .xl-expire {
    font-size: 12px;
    color: #999;
    margin-left: 12px;
  }

  .icon-baobiaokongzhitai {
    cursor: pointer;
  }

  .ivu-layout,
  .ivu-layout-content {
    height: 100%;
  }

  .free-version {
    background: #fdf2e2;
    padding: 12px 24px;
    color: #666;
    margin-bottom: 12px;
  }

  .free-version .free-tag {
    display: inline-block;
    padding: 2px 6px;
    border: 1px solid #0c6;
    color: #0c6;
    font-size: 12px;
  }

  .w7-style {
    width: 100%;
    margin-top: 20px;
    text-align: center;
  }

  .w7-style .flex {
    justify-content: center;
  }

  .w7-style .t {
    margin: 0px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue